import React from 'react';

import MetricBox from './MetricBox';

interface OrientationProps {
  heading: number;
  pitch: number;
  roll: number;
}

const OrientationIndicator: React.FC<OrientationProps> = ({ heading, pitch, roll }) => (
  <div className='flex space-x-2'>
    <MetricBox label='Heading' value={`${Math.round(heading)}°`} />
    <MetricBox label='Pitch' value={`${pitch.toFixed(1)}°`} />
    <MetricBox label='Roll' value={`${roll.toFixed(1)}°`} />
  </div>
);

export default OrientationIndicator;
